import { render } from "./LitterRegistrationView.vue?vue&type=template&id=247e72b9&scoped=true"
import script from "./LitterRegistrationView.vue?vue&type=script&lang=js"
export * from "./LitterRegistrationView.vue?vue&type=script&lang=js"

import "./LitterRegistrationView.vue?vue&type=style&index=0&id=247e72b9&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247e72b9"]])

export default __exports__